import {
  coursesConstants,
} from '../constants/coursesConstants';

// const localCourses = JSON.parse(sessionStorage.getItem('courses'));

const initialState = { requesting: true };

export default function courses(state = initialState, action) {
  switch (action.type) {
    case coursesConstants.GET_COURSES_REQUEST:
      return {
        requesting: true,
      };
    case coursesConstants.GET_COURSES_SUCCESS:
      return {
        requesting: false,
        courses: action.courses,
      };
    case coursesConstants.GET_COURSES_FAILURE:
      return {
        requesting: false,
      };
    case coursesConstants.SET_COURSES:
      return {
        courses: action.courses,
      };
    case coursesConstants.UNSET_COURSES:
      return {};
    default:
      return state;
  }
}
